import React from "react"
import { useState, useEffect, useRef } from "react"
import { Container, Tab, Tabs, OverlayTrigger, Popover } from "react-bootstrap"
import ModuloNonAttivo from "../ModuloNonAttivo";
import { useNavigate, useLocation } from "react-router-dom";
import PaginaNonTrovata from "../../Utente/Error/PaginaNonTrovata"
import { BsQuestionCircle } from "react-icons/bs"
import ImpostazioniSondaggi from "./ImpostazioniSondaggi"
import SondaggiService from "../../../services/SondaggiService"
import TabellaSondaggi from "./TabellaSondaggi";
import GestisciSondaggio from "./GestisciSondaggio";
import RisposteElenco from "./Risposte/RisposteElenco"

/*
PROPS: 
comune={comune} 
setRicaricaComune={setRicaricaComune} 
tabAttivaSondaggi={tabAttivaSondaggi} 
setTabAttivaSondaggi={setTabAttivaSondaggi} 
mostraTabella={mostraTabellaSondaggi} 
setMostraTabella={setMostraTabellaSondaggi} 
partecipante={partecipante}

*/
const DRAFT_SESSION_KEY = "sondaggio_draft_in_progress";


export default function Sondaggi(props) {

    const navigate = useNavigate();
    const location = useLocation();

    //Stato per controllare dove fosse prima di andare in impostazioni, cosi che se vengono aggiunte nuove caegorie non si perda l'informazione sul sondaggio che si stava creando
const ultimoGestisciRef = useRef(null);

    //stato per non perdere le informazioni del sondaggio che si sta creando 
    const [draftSondaggio, setDraftSondaggio] = useState({});


    // Dirty bit
    let [dirty, setDirty] = useState(true)

    // Stoppa il ricaricamento dei dati quando vengono caricati la prima volta. Viene riattivato quando c'è bisogno di caricare nuovamente i dati del db
    // (dopo) un inserimento di righe
    let [stopLoading, setStopLoading] = useState(false)

    // Fetch sondaggi
    let [sondaggi, setSondaggi] = useState([])

    //Stato che decide come deve essere gestito il sondaggio
    let [gestisci, setGestisci] = useState("")

    //Stato per l'applicazione del filtro stato sui sondaggi
    let [statoFilter, setStatoFilter] = useState("")

    //Stato per l'applicazione del filtro delle categorie sui sondaggi
    let [categoriaFilter, setCategoriaFilter] = useState("")

    //Stato che passa l'id del sondaggio
    let [sonId, setSonId] = useState()

    useEffect(() => {
        if (dirty && props.comune) {
            SondaggiService.getAllByComune(props.comune.comId)
                .then(res => {
                    setSondaggi(res.data)
                })
                .then(() => {
                    setStopLoading(false)
                })
                .catch((err) => {
                    setSondaggi([])
                })
                .finally(() => {
                    if (props.comune.comId)
                        setDirty(false)
                })
        }
    }, [props.comune, dirty]);

    const toggleTab = (ev) => {
        const targetKey = ev.target.dataset.rrUiEventKey;
    console.log("targetKey: ", targetKey)
        if (targetKey === "impostazioni") {
            console.log("gestisci: ", gestisci)
    if (gestisci) {
        sessionStorage.setItem("gestione_sondaggio", JSON.stringify({
            gestisci,
            draftSondaggio
        }));
    } else {
        sessionStorage.removeItem("gestione_sondaggio");
    }
    props.setTabAttivaSondaggi("impostazioni");
    navigate("/admin/sondaggi#impostazioni");
}



        if (targetKey === "sondaggi") {
    props.setTabAttivaSondaggi("sondaggi");

    const saved = sessionStorage.getItem("gestione_sondaggio");
    console.log("saved: ", saved)
    if (saved) {
        const { gestisci, draftSondaggio } = JSON.parse(saved);
        if (gestisci == "aggiungi-sondaggio") {
            setGestisci(gestisci);
            setDraftSondaggio(draftSondaggio);
            props.setMostraTabella(false);
            sessionStorage.removeItem("gestione_sondaggio");
        }else{
            props.setMostraTabella(true);
            sessionStorage.removeItem("gestione_sondaggio");
        }
    } else {
        props.setMostraTabella(true);
                    sessionStorage.removeItem("gestione_sondaggio");

        setGestisci("tabella")
    }

    navigate("/admin/sondaggi#tutti-i-sondaggi");
}





    
        
    }
    //useEffect utilizzata al click dell'amministratore sulla sidebar su sondaggi per verificare cosa deve essere visualizzato
    useEffect(() => {
        if (location.hash === "#tutti-i-sondaggi") props.setTabAttivaSondaggi("sondaggi")
        if (location.hash === "#impostazioni") props.setTabAttivaSondaggi("impostazioni")
    }, [props, location])

    if (props.partecipante.parId && props.partecipante.ruolo.ruoFlAmministratore) {
        return (
            <Container fluid="lg">
                <div className="d-flex justify-content-between">
                    <h1 className="title">{props.comune.impostazioniComune.imcLabelModuloSondaggi}</h1>
                    {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSondaggiAttivo &&
                        <OverlayTrigger placement="left" trigger="click" rootClose
                            overlay={
                                <Popover id="popover-contained">
                                    <Popover.Header as="h3">Aiuto:</Popover.Header>
                                    <Popover.Body>
                                        Ecco tutti i {props.comune.impostazioniComune.imcLabelModuloSondaggi} creati.
                                        <br />
                                        <br />
                                        Possibili <strong>stati</strong>:
                                        <ul>
                                            <li><strong>In corso</strong>: sondaggio visibile e compilabile dai partecipanti</li>
                                            <li><strong>Pubblicato</strong>: sondaggio visibile ai partecipanti ma non ancora compilabile</li>
                                            <li><strong>Non pubblicato</strong>: sondaggio non ancora completo e non visibile ai partecipanti</li>
                                            <li><strong>Concluso</strong>: sondaggio che ha raggiunto la sua data di chiusura</li>
                                        </ul>
                                        <br />
                                        Possibili <strong>azioni</strong>:
                                        <ul>
                                            <li><strong>Nuovo +</strong>: per creare un nuovo sondaggio</li>
                                            <li><strong>Controlla</strong>: per modificare i dati o le domande del sondaggio </li>
                                            <li><strong>Risposte</strong>: per gestire e visualizzare l'andamento delle risposte al sondaggio</li>
                                        </ul>
                                    </Popover.Body>
                                </Popover>
                            }
                        >
                            <div className="my-auto" style={{ cursor: "pointer" }}>
                                <BsQuestionCircle size="2em" className="my-auto" />
                            </div>
                        </OverlayTrigger>
                    }
                </div>
                {props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcModuloSondaggiAttivo ? (
                    <Tabs activeKey={props.tabAttivaSondaggi} id="uncontrolled-tab-example" className="mb-3" onClick={toggleTab}>
                        <Tab eventKey="sondaggi" title={`Tutti i ${props.comune.impostazioniComune.imcLabelModuloSondaggi}`}>
                            {
                                props.mostraTabella ? (
                                    <TabellaSondaggi
                                        comune={props.comune}
                                        sondaggi={sondaggi}
                                        setSonId={setSonId}
                                        setMostraTabella={props.setMostraTabella}
                                        setGestisci={setGestisci}
                                        statoFilter={statoFilter}
                                        setStatoFilter={setStatoFilter}
                                        setDirty={setDirty}
                                        dirty={dirty}
                                        categoriaFilter={categoriaFilter}
                                        setCategoriaFilter={setCategoriaFilter}
                                    />
                                ) : gestisci === "visualizza-risposte" ? (
                                    <>
                                        {/* Contenuto per visualizzare risposte */}
                                        <RisposteElenco
                                            comune={props.comune}
                                            sondaggi={sondaggi}
                                            sonId={sonId}
                                            setMostraTabella={props.setMostraTabella}
                                            setGestisci={setGestisci}
                                            gestisci={gestisci}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {/* Contenuto per aggiungere o gestire un sondaggio */}
                                        <GestisciSondaggio
                                            comune={props.comune}
                                            sonId={sonId}
                                            setMostraTabella={props.setMostraTabella}
                                            gestisci={gestisci}
                                            setGestisci={setGestisci}
                                            setDirty={setDirty}
                                            draftSondaggio={draftSondaggio}
                                            setDraftSondaggio={setDraftSondaggio}
                                            dirty={dirty}
                                        />
                                    </>
                                )
                            }
                        </Tab>
                        <Tab eventKey="impostazioni" title="Impostazioni">
                            <ImpostazioniSondaggi
                                sondaggi={sondaggi}
                                stopLoading={stopLoading}
                                setStopLoading={setStopLoading}
                                setDirty={setDirty}
                                comune={props.comune}
                                setRicaricaComune={props.setRicaricaComune}
                                setMostraTabella={props.setMostraTabella}
                                ultimoGestisci={ultimoGestisciRef}
                            />
                        </Tab>
                    </Tabs>
                ) : (

                    <ModuloNonAttivo moduleName="Sondaggi" />
                )}
            </Container>
        )
    } else {
        return (
            <PaginaNonTrovata />
        )
    }

}